<template>
  <v-container class="banner-container">
    <!-- skeleton -->
    <v-container class="pa-0 ma-0 cover-wrapper" v-if="loading">
      <v-skeleton-loader type="image" class="cover-skeleton" height="180" />
      <v-container class="pa-0 ma-0 d-flex align-start gap-8">
        <!-- Image -->
        <v-skeleton-loader type="image" class="icon-overlay" width="98" height="98" />
        <!-- Text wrapper -->
        <v-container
          class="pa-0 ma-0 d-flex flex-column justify-center aling-end mr-15 my-4 px-3 pr-15"
          style="flex: 1"
        >
          <v-skeleton-loader type="text" height="18" max-width="60%" />
          <v-skeleton-loader type="text" height="16" max-width="40%" class="mt-2" />
        </v-container>
      </v-container>
    </v-container>
    <!--banner img -->
    <v-img
      v-if="!loading"
      :src="coverURL ? coverURL : require('@/assets/shopping/placeHolderImage.png')"
      alt="Banner"
      class="banner-img"
    />

    <!--logo and title&subtitle wrapper -->
    <v-container v-if="!loading" class="pa-0 ma-0 overlay-content">
      <v-img
        :src="iconURL ? iconURL : require('@/assets/shopping/placeHolderImage.png')"
        alt="Logo"
        class="logo"
      />
      <v-container class="d-flex flex-column pa-0 ma-0">
        <v-card-text class="title-text px-4 ma-0 pt-5 pa-0">
          {{ titleHeroSection }}
        </v-card-text>
        <v-card-text class="pa-0 sub-text pt-1 px-4">
          {{ SubtitleHeroSection }}
        </v-card-text>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
export default {
  props: {
    coverURL: {
      type: String,
      default: "",
    },
    iconURL: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    titleHeroSection: "",
    SubtitleHeroSection: "",
    BannerImage: "",
    BannerLogo: "",
    loading: true,
  }),
  watch: {
    coverURL(newVal) {
      if (newVal) {
        this.loading = false;
      }
    },
    iconURL(newVal) {
      if (newVal) {
        this.loading = false;
      }
    },
    name(newVal) {
      if (newVal) {
        this.titleHeroSection = newVal;
        this.loading = false;
      }
    },
    desc(newVal) {
      if (newVal) {
        this.SubtitleHeroSection = newVal;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.banner-container {
  max-width: 680px;
  margin: 0 auto;
  border-radius: 12px;
  position: relative;
  direction: rtl;
}
.banner-img {
  width: 100%;
  height: auto;
  min-height: 200px;
  display: block;
}
.overlay-content {
  position: absolute;
  bottom: -65px;
  right: 50px;
  display: flex;
  align-items: center;
  z-index: 99;
}
.logo {
  width: 90px;
  height: 90px;
  z-index: 99;
  border-radius: 12px;
}
.title-text {
  padding-top: 20px;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
}
.sub-text {
  font-weight: 400;
  font-size: 12px !important;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.cover-wrapper {
  position: relative;
}

.cover-skeleton {
  width: 100%;
}

.icon-overlay {
  position: absolute;
  bottom: 20px;
  right: 5px;
  border-radius: 12px;
}

/* @media (max-width: 1024px) {
  .overlay-content {
    bottom: -65px;
    right: 50px;
  }
  .logo {
    width: 90px;
    height: 90px;
  }
} */
@media (max-width: 650px) {
  .overlay-content {
    bottom: -50px;
    right: 50px;
  }
  .logo {
    width: 90px;
    height: 90px;
  }
}
@media (max-width: 580px) {
  .overlay-content {
    bottom: -43px;
    right: 30px;
  }
  .logo {
    width: 80px;
    height: 80px;
  }
  .title-text {
    font-size: 14px;
  }
}
</style>
